__turbopack_context__.v({
  "description": "StateMessage-module-scss-module__cq04sq__description",
  "link": "StateMessage-module-scss-module__cq04sq__link",
  "primaryButton": "StateMessage-module-scss-module__cq04sq__primaryButton",
  "root": "StateMessage-module-scss-module__cq04sq__root",
  "title": "StateMessage-module-scss-module__cq04sq__title",
});
